import { ProductStatus } from 'generated/graphql';
import { required as requiredValidator, SelectInput, SelectInputProps } from 'react-admin';

import { PRODUCT_STATUSES } from '../productUtils';

export type ProductStatusInputProps = SelectInputProps;

const productStatuses = [
  { id: ProductStatus.WaitingForSubmission, name: PRODUCT_STATUSES[ProductStatus.WaitingForSubmission] },
  { id: ProductStatus.Processing, name: PRODUCT_STATUSES[ProductStatus.Processing] },
  { id: ProductStatus.Active, name: PRODUCT_STATUSES[ProductStatus.Active] },
];

export const ProductStatusInput: React.FC<ProductStatusInputProps> = ({
  choices = productStatuses,
  defaultValue = ProductStatus.Processing,
  validate = [requiredValidator()],
  ...restProps
}) => {
  return <SelectInput choices={choices} defaultValue={defaultValue} validate={validate} {...restProps} />;
};
